import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import Button from '@mui/material/Button';
import { useCallback } from 'react';
import { BLUESKY_ACCOUNT_URL } from '../../constants/constants';
import { BlueskyIcon } from '../../icons/blueskyIcon';
export const BlueskyButton = ({ size = 'small', label = '@triplejack.com', variant = 'contained' }) => {
    const onClick = useCallback(() => {
        window.open(BLUESKY_ACCOUNT_URL, '_blank');
    }, []);
    return (_jsx(Button, { onClick: onClick, variant: variant, size: size, startIcon: _jsx(BlueskyIcon, {}), endIcon: _jsx(LaunchRoundedIcon, { style: { opacity: 0.4 } }), children: label }));
};
